<template>
<div class="Modelo145Edit">
    <ValidationObserver ref="formModelo">
        <div class="card mb-3">
            <div class="body">                      
                <ul class="nav nav-tabs mb-1">
                    <li class="nav-item">
                        <button :class="'nav-link ' + ((selectedTab == 'datosPersonales') ? 'active' : '')" @click.prevent="selectedTab = 'datosPersonales'"><i class="ms-Icon ms-Icon--ContactInfo tab-icon align-middle"></i> 1. {{ $t('datosPersonales') }}</button>
                    </li>
                    <li class="nav-item">
                        <button :class="'nav-link ' + ((selectedTab == 'descendientes') ? 'active' : '')" @click.prevent="selectedTab = 'descendientes'"><i class="ms-Icon ms-Icon--Group tab-icon align-middle"></i> 2. {{ $t('descendientes') }}</button>
                    </li>
                    <li class="nav-item">
                        <button :class="'nav-link ' + ((selectedTab == 'ascendientes') ? 'active' : '')" @click.prevent="selectedTab = 'ascendientes'"><i class="ms-Icon ms-Icon--ReminderGroup tab-icon align-middle"></i> 3. {{ $t('ascendientes') }}</button>
                    </li>
                    <li class="nav-item">
                        <button :class="'nav-link ' + ((selectedTab == 'pensiones') ? 'active' : '')" @click.prevent="selectedTab = 'pensiones'"><i class="ms-Icon ms-Icon--PaymentCard tab-icon align-middle"></i> 4. {{ $t('pensiones') }}</button>
                    </li>
                    <li class="nav-item">
                        <button :class="'nav-link ' + ((selectedTab == 'pagos') ? 'active' : '')" @click.prevent="selectedTab = 'pagos'"><i class="ms-Icon ms-Icon--Money tab-icon align-middle"></i> 5. {{ $t('pagos') }}</button>
                    </li>
                </ul>              
                <div v-if="selectedTab == 'datosPersonales'">
                    <div class="row clearfix">                            
                        <div class="col-md-4 col-xs-12">
                            <small class="text-muted">
                                <span>{{ $t('NIF') }}</span></small>
                            <p>{{nif}}</p>                                
                        </div>

                        <div class="col-md-4 col-xs-12">
                            <small class="text-muted">
                                <span>{{ $t('apellidosNombre') }}</span></small>
                            <p>{{primerApellido}} {{segundoApellido}} {{nombre}}</p>                                
                        </div>

                        <div class="col-md-4 col-xs-12">
                            <small class="text-muted">
                                <span>{{ $t('añoNacimiento') }}:</span></small>
                            <p>{{fecNacimiento}}</p>
                        </div>
                    </div>
                    <span>{{ $t('seleccioneSituacionFamiliar') }}</span>
                    <br>
                    <div class="form-check">
                        <input @change="validateDescendientes" type="radio" id="st1" value="0" v-model="modelData.situacionFamiliar" name="cbsituacionFamiliar" class="form-check-input m-r-20">
                        <label for="st1"><strong>{{ $t('situacionFamiliar') }} 1.</strong> {{ $t('situacionFamiliar0') }}</label>
                    </div>
                    <div class="form-check">
                        <input @change="validateDescendientes" type="radio" id="st2" value="1" v-model="modelData.situacionFamiliar" name="cbsituacionFamiliar" class="form-check-input m-r-20">
                        <label for="st2"><strong>{{ $t('situacionFamiliar') }} 2.</strong> {{ $t('situacionFamiliar1') }}</label>
                    </div>
                    <div class="form-check">
                        <input @change="validateDescendientes" type="radio" id="st3" value="2" v-model="modelData.situacionFamiliar" name="cbsituacionFamiliar" class="form-check-input m-r-20">
                        <label for="st3"><strong>{{ $t('situacionFamiliar') }} 3.</strong> {{ $t('situacionFamiliar2') }}</label>
                    </div>
                    <div class="row clearfix"> 
                        <div class="col-md-4 col-xs-12" v-if="modelData.situacionFamiliar == 1">
                            <ValidationProvider :rules="rules.nif" name="vpNifConyuge" v-slot="{ errors, valid, validated }"> 
                                <div class="form-group" :class="{'error': !valid && validated}">
                                <span>{{ $t('nifConyuge') }}</span>
                                    <div :class="{'valid': valid && validated}">
                                        <input name="nifConyuge" maxlength="9" v-model="modelData.nifConyuge" class="form-control" />
                                    </div>
                                    <span class="displayError">{{ errors[0] }}</span>       
                                </div>
                            </ValidationProvider> 
                        </div>
                        <div class="col-md-4 col-xs-12">
                            <span>{{ $t('gradoDiscapacidad') }}: </span>
                            <select v-model="modelData.tipoDiscapacidad" class="form-control mb-1">
                                <option value="0">{{ $t('gradoDiscapacidad0') }}</option>
                                <option value="1">{{ $t('gradoDiscapacidad1') }}</option>
                                <option value="2">{{ $t('gradoDiscapacidad2') }}</option>
                            </select>       
                            <div class="checkbox">
                                <input id="cbAyuda" type="checkbox" true-value="1" false-value="0" name="cbAyuda" v-model="modelData.conNecesidadAyuda">
                                <label for="cbAyuda">{{ $t('ayuda') }}</label>
                            </div>                                
                        </div>

                        <div class="col-md-4 col-xs-12">
                            <span>{{ $t('movGeografica') }}</span>
                            <InputDate v-model="fechaMovilidadGeograficaProp" @select="(v) => selectDateMoviGeo(v)" @click="(v) => clickInputDateMoviGeo(v)"></InputDate>              
                        </div>                    
                    </div>
                    <div class="checkbox">
                        <input id="cbRendimientos" type="checkbox" true-value="1" false-value="0" name="cbRendimientos" v-model="modelData.rdtos2Anos5Anteriores">
                        <label for="cbRendimientos">{{ $t('obtencionRendimientos') }}</label>
                    </div>  
                </div>  

                <div v-if="selectedTab == 'descendientes'">
                    <BTable hover :items="descendientes" :fields="fieldsDescendientes">
                        <template v-slot:cell(anoNacimiento)="data">
                            <ValidationProvider :rules="rules.numericField" name="vpAñoNacimiento" v-slot="{ errors, valid, validated }"> 
                                <div class="form-group" :class="{'error': !valid && validated}">
                                    <div :class="{'valid': valid && validated}">
                                        <input v-model="data.item.anoNacimiento" type="string" class="form-control" maxlength="4" v-on:input="validateDescendientes" />
                                    </div>
                                <span class="displayError">{{ errors[0] }}</span>       
                            </div>
                        </ValidationProvider>  
                        </template>
                        <template v-slot:cell(anoAdopcion)="data">
                            <ValidationProvider :rules="rules.numericField" name="vpAñoAdopcion" v-slot="{ errors, valid, validated }"> 
                                <div class="form-group" :class="{'error': !valid && validated}">
                                    <div :class="{'valid': valid && validated}">
                                        <input v-model="data.item.anoAdopcion" type="string" class="form-control" maxlength="4" />
                                    </div>
                                <span class="displayError">{{ errors[0] }}</span>       
                            </div>
                        </ValidationProvider>  
                        </template>
                        <template v-slot:cell(tipoDiscapacidad)="data">
                            <select v-model="data.item.tipoDiscapacidad" class="form-control mb-1">
                                <option value="0">{{ $t('gradoDiscapacidad0') }}</option>
                                <option value="1">{{ $t('gradoDiscapacidad1') }}</option>
                                <option value="2">{{ $t('gradoDiscapacidad2') }}</option>
                            </select>                             
                        </template>
                        <template v-slot:cell(conNecesidadAyuda)="data">
                            <div class="checkbox">
                                <input :id="'cbAyudaEdit'+data.index" type="checkbox" true-value="1" false-value="0" :name="'cbAyudaEdit'+data.index" v-model="data.item.conNecesidadAyuda">
                                <label :for="'cbAyudaEdit'+data.index"></label>
                            </div>
                        </template>
                        <template v-slot:cell(tipoComputo)="data">
                            <div class="checkbox">
                                <input :id="'cbDescendienteEdit'+data.index" @change="validateDescendientes" type="checkbox" true-value="1" false-value="0" :name="'cbDescendienteEdit'+data.index" v-model="data.item.tipoComputo">
                                <label :for="'cbDescendienteEdit'+data.index"></label>
                            </div>
                        </template>
                    </BTable>
                    <div v-if="!validDescendientes">
                        <BAlert show variant="danger" class="p-1">{{ errorDescendientes }}</BAlert>
                    </div>
                </div> 

                <div v-if="selectedTab == 'ascendientes'">
                    <BTable hover :items="ascendientes" :fields="fieldsAscendientes">
                        <template v-slot:cell(anoNacimiento)="data">
                            <ValidationProvider :rules="rules.numericField" name="vpAñoNacimientoAscen" v-slot="{ errors, valid, validated }"> 
                                <div class="form-group" :class="{'error': !valid && validated}">
                                    <div :class="{'valid': valid && validated}">
                                        <input v-model="data.item.anoNacimiento" type="string" class="form-control" maxlength="4"/>
                                    </div>
                                    <span class="displayError">{{ errors[0] }}</span>       
                                </div>
                            </ValidationProvider>  
                        </template>                        
                        <template v-slot:cell(tipoDiscapacidad)="data">
                            <select v-model="data.item.tipoDiscapacidad" class="form-control mb-1">
                                <option value="0">{{ $t('gradoDiscapacidad0') }}</option>
                                <option value="1">{{ $t('gradoDiscapacidad1') }}</option>
                                <option value="2">{{ $t('gradoDiscapacidad2') }}</option>
                            </select>                             
                        </template>
                        <template v-slot:cell(conNecesidadAyuda)="data">
                            <div class="checkbox">
                                <input :id="'cbAyudaEdit'+data.index" type="checkbox" true-value="1" false-value="0" :name="'cbAyudaEdit'+data.index" v-model="data.item.conNecesidadAyuda">
                                <label :for="'cbAyudaEdit'+data.index"></label>
                            </div>
                        </template>
                        <template v-slot:cell(conviveDesc)="data">
                            <ValidationProvider :rules="rules.numericField" name="vpnumDescConvAscen" v-slot="{ errors, valid, validated }"> 
                                <div class="form-group" :class="{'error': !valid && validated}">
                                    <div :class="{'valid': valid && validated}">
                                        <input v-model="data.item.conviveDesc" type="string" class="form-control" maxlength="4"/>
                                    </div>
                                    <span class="displayError">{{ errors[0] }}</span>       
                                </div>
                            </ValidationProvider> 
                        </template>
                    </BTable>              
                </div>

                <div v-if="selectedTab == 'pensiones'">
                    <div class="row clearfix">                            
                        <div class="col-md-6 col-xs-12">
                            <ValidationProvider :rules="rules.importe" name="vpRentasConyuge" v-slot="{ errors, valid, validated }"> 
                                <div class="form-group" :class="{'error': !valid && validated}">
                                    <span>{{ $t('importePensionConyuge') }}</span>
                                    <div :class="{'valid': valid && validated}">
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text" style="font-size: 12px">€</span>
                                            </div>
                                            <input MaxLength="40" Class="form-control input-sm" placeholder="0,00" v-model="modelData.rentasConyuge">
                                        </div>
                                    </div>
                                    <span class="displayError">{{ errors[0] }}</span>       
                                </div>
                            </ValidationProvider>
                        </div>
                        <div class="col-md-6 col-xs-12">
                            <ValidationProvider :rules="rules.importe" name="vpRentasDescendientes" v-slot="{ errors, valid, validated }"> 
                                <div class="form-group" :class="{'error': !valid && validated}">
                                    <span>{{ $t('importeAnualAlimentos') }}</span>
                                    <div :class="{'valid': valid && validated}">
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text" style="font-size: 12px">€</span>
                                            </div>
                                            <input MaxLength="40" Class="form-control input-sm" placeholder="0,00" v-model="modelData.rentasDescendientes">
                                        </div>
                                    </div>
                                    <span class="displayError">{{ errors[0] }}</span>       
                                </div>
                            </ValidationProvider>
                        </div>
                    </div>
                </div>

                <div v-if="selectedTab == 'pagos'">
                    <div class="checkbox">
                        <input id="cbPagosAdquisViviendas" type="checkbox" true-value="1" false-value="0"  name="cbPagosAdquisViviendas" v-model="modelData.pagosAdquisViviendas">
                        <label for="cbPagosAdquisViviendas">{{ $t('pagosForm1') }}</label>
                    </div>  
                </div>            
            </div>
        </div> 
        <div class="row clearfix">                            
            <div class="col">
                <a class="btn btn-primary waves-effect waves-light btn-submit-success hidden-progress" @click.prevent="enviar()">{{ $t('enviar') }}</a>
                <router-link to="/model145" class="ml-1 btn btn-secondary waves-effect waves-light btn-submit-cancel">{{ $t('cancelar') }}
                </router-link>
            </div>
        </div>
    </ValidationObserver>
    <Datepicker @select="(v) => selectDateMoviGeo(v)" ref="modaldatepickerMoviGeo"></Datepicker>
    
</div>
</template>

<style scoped>
#FotoUsuario {
    width: 170px;
}
</style>

<script>
import { modelService } from '@/api/model';
import moment from 'moment';
import Datepicker from '@/components/common/mmDatepicker.vue';
import InputDate from '@/components/common/mmInputDate.vue';
import { rules } from "@/_helpers/validations/validate-model";
import { BTable } from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { BAlert } from 'bootstrap-vue'

export default {
    name: 'Modelo145Edit',
    props: {
        descendientesProp: Array,
        ascendientesProp: Array,
        nifProp: String,
        primerApellidoProp: String,
        segundoApellidoProp: String,
        fecNacimientoProp: String,
        nombreProp: String
    },
    components: {
        Datepicker,
        InputDate,
        BAlert,
        BTable,
        ValidationObserver,
        ValidationProvider
    },
    data(){
        return {
            rules,
            selectedTab: 'datosPersonales',
            fechaMovilidadGeograficaProp: '',
            modelData: {
                noLinea: 0,
                codTrabajador: this.nifProp,
                anoEjercicio: "",
                codEmpresa: "",
                situacionFamiliar: 0,
                nifConyuge: "",
                discapContribuyente: 0,
                rentasConyuge: 0.00,
                rentasDescendientes: 0.00,
                conNecesidadAyuda: 0,
                fechaMovilidadGeografica: "",
                rdtos2Anos5Anteriores: 0,
                pagosAdquisViviendas: 0,
                anoNacimientoHijo1: "",
                tipoDiscapacidadHijo1: 0,
                computoEnteroHijo1: 0,
                anoAdopcionHijo1: "",
                movilidadReducidaHijo1: 0,
                anoNacimientoHijo2: "",
                tipoDiscapacidadHijo2: 0,
                computoEnteroHijo2: 0,
                anoAdopcionHijo2: "",
                movilidadReducidaHijo2: 0,
                anoNacimientoHijo3: "",
                tipoDiscapacidadHijo3: 0,
                computoEnteroHijo3: 0,
                anoAdopcionHijo3: "",
                movilidadReducidaHijo3: 0,
                anoNacimientoHijo4: "",
                tipoDiscapacidadHijo4: 0,
                computoEnteroHijo4: 0,
                anoAdopcionHijo4: "",
                movilidadReducidaHijo4: 0,
                anoNacimientoHijo5: "",
                tipoDiscapacidadHijo5: 0,
                computoEnteroHijo5: 0,
                anoAdopcionHijo5: "",
                movilidadReducidaHijo5: 0,
                anoNacimientoAsc1: "",
                tipoDiscapacidadAsc1: 0,
                movilidadReducidaAsc1: 0,
                numPersonasConvAsc1: 0,
                anoNacimientoAsc2: "",
                tipoDiscapacidadAsc2: 0,
                movilidadReducidaAsc2: 0,
                numPersonasConvAsc2: 0,
                noLineaAuxiliar: 0,
                noLineaExterno: 0,
                noLineaDiarioAltas: 0,
                codPerfilGeneral: "",
                codPerfilServicio: "",
                pendienteRegistroWeb: 0,                
                codPerfilAprobacion: "",
                nivelAprobacion: 0,
                nivelCreacion: 0,
                usuarioWeb: "",
                fechaCreacion: "",
                horaCreacion: ""
            },
            descendientes: (this.descendientesProp.length != 0) ? this.descendientesProp : [
                {anoNacimiento: '', anoAdopcion: '', tipoDiscapacidad: 0, conNecesidadAyuda: 0, tipoComputo: 0},
                {anoNacimiento: '', anoAdopcion: '', tipoDiscapacidad: 0, conNecesidadAyuda: 0, tipoComputo: 0},
                {anoNacimiento: '', anoAdopcion: '', tipoDiscapacidad: 0, conNecesidadAyuda: 0, tipoComputo: 0},
                {anoNacimiento: '', anoAdopcion: '', tipoDiscapacidad: 0, conNecesidadAyuda: 0, tipoComputo: 0},
                {anoNacimiento: '', anoAdopcion: '', tipoDiscapacidad: 0, conNecesidadAyuda: 0, tipoComputo: 0}
            ],
            ascendientes: (this.ascendientesProp.length != 0) ? this.ascendientesProp : [
                {anoNacimiento: '', tipoDiscapacidad: 0, conNecesidadAyuda: 0, numPersonasConvivenc: 0},
                {anoNacimiento: '', tipoDiscapacidad: 0, conNecesidadAyuda: 0, numPersonasConvivenc: 0}
            ],
            fieldsDescendientes: [
                {
                    key: 'anoNacimiento',
                    sortable: false,
                    label:  this.$i18n.t('añoNacimiento') 
                },
                {
                    key: 'anoAdopcion',
                    sortable: false,
                    label: this.$i18n.t('añoAdopcion') 
                },
                {
                    key: 'tipoDiscapacidad',
                    label: this.$i18n.t('gradoDiscapacidad') ,
                    sortable: false,
                },
                {
                    key: 'conNecesidadAyuda',
                    label: this.$i18n.t('ayuda') ,
                    sortable: false,
                },
                {
                    key: 'tipoComputo',
                    label: this.$i18n.t('computoEntero') ,
                    sortable: false,
                }
            ],
            fieldsAscendientes: [
                {
                    key: 'anoNacimiento',
                    sortable: false,
                    label:  this.$i18n.t('añoNacimiento') 
                },
                {
                    key: 'tipoDiscapacidad',
                    label: this.$i18n.t('gradoDiscapacidad') ,
                    sortable: false,
                },
                {
                    key: 'conNecesidadAyuda',
                    label: this.$i18n.t('ayuda') ,
                    sortable: false,
                },
                {
                    key: 'numPersonasConvivenc',
                    label: this.$i18n.t('numDescConv') ,
                    sortable: false,
                }
            ],
            nif: this.nifProp,
            primerApellido: this.primerApellidoProp,
            segundoApellido: this.segundoApellidoProp,
            fecNacimiento: this.fecNacimientoProp,
            nombre: this.nombreProp,
            validDescendientes: true,
            errorDescendientes: ''

        }
    },
    async mounted () {
        let modelData = await modelService.getModelDataModify();
        if (modelData != null)
            this.modelData = modelData;
        if (this.modelData.fechaMovilidadGeografica && !this.modelData.fechaMovilidadGeografica.includes('01/01/1753')){
            this.fechaMovilidadGeograficaProp = moment(String(this.modelData.fechaMovilidadGeografica)).format('DD/MM/YYYY')
        }
        else
            this.fechaMovilidadGeograficaProp = '';
    },
    methods: {
        validateDescendientes(){
            if (this.modelData.situacionFamiliar == 0){
                if (this.descendientes[0].anoNacimiento == '' && this.descendientes[1].anoNacimiento == '' && this.descendientes[2].anoNacimiento == '' && this.descendientes[3].anoNacimiento == '' && this.descendientes[4].anoNacimiento == '')
                {
                    this.validDescendientes = false;
                    this.selectedTab = 'descendientes';
                    this.errorDescendientes = this.$i18n.t('errorSituacionFamiliar1');
                }
                else if (this.descendientes[0].tipoComputo == 0 && this.descendientes[1].tipoComputo == 0 && this.descendientes[2].tipoComputo == 0 && this.descendientes[3].tipoComputo == 0 && this.descendientes[4].tipoComputo == 0)
                {
                    this.validDescendientes = false;
                    this.selectedTab = 'descendientes';
                    this.errorDescendientes = this.$i18n.t('errorSituacionFamiliar1ComputoEntero');
                }
                else this.validDescendientes = true;
            }
        },
        clickInputDateMoviGeo(value) {
            this.$refs.modaldatepickerMoviGeo.openModal(value);    
        },
        selectDateMoviGeo(value) {
            if (!value.includes('_')){
                this.fechaMovilidadGeograficaProp = moment(String(value), 'DD/MM/YYYY').format('DD/MM/YYYY'); 
                this.modelData.fechaMovilidadGeografica = moment(String(value), 'DD/MM/YYYY').format('YYYY-MM-DD[T]HH:mm:ss');
            }
        },
        async enviar(){
            let self = this;
            this.$refs.formModelo.validate().then(valid => {     
                if (valid && this.validDescendientes) {
                    this.modelData.fechaMovilidadGeografica = (this.modelData.fechaMovilidadGeografica == "") ? new Date('1753-01-01T00:00:00') : this.modelData.fechaMovilidadGeografica;
                    this.modelData.fechaNacHijo1 = (this.modelData.fechaNacHijo1 == "") ? new Date('1753-01-01T00:00:00') : this.modelData.fechaNacHijo1;
                    this.modelData.fechaNacHijo2 = (this.modelData.fechaNacHijo2 == "") ? new Date('1753-01-01T00:00:00') : this.modelData.fechaNacHijo2;
                    this.modelData.fechaNacHijo3 = (this.modelData.fechaNacHijo3 == "") ? new Date('1753-01-01T00:00:00') : this.modelData.fechaNacHijo3;
                    this.modelData.fechaNacHijo4 = (this.modelData.fechaNacHijo4 == "") ? new Date('1753-01-01T00:00:00') : this.modelData.fechaNacHijo4;
                    this.modelData.fechaNacHijo5 = (this.modelData.fechaNacHijo5 == "") ? new Date('1753-01-01T00:00:00') : this.modelData.fechaNacHijo5;
                    this.modelData.fechaCreacion = (this.modelData.fechaCreacion == "") ? new Date('1753-01-01T00:00:00') : this.modelData.fechaCreacion;
                    this.modelData.horaCreacion = (this.modelData.horaCreacion == "") ? new Date('1753-01-01T00:00:00') : this.modelData.horaCreacion;
                    

                    this.modelData.anoNacimientoHijo1 = this.descendientes[0].anoNacimiento;
                    this.modelData.anoAdopcionHijo1 = this.descendientes[0].anoAdopcion;
                    this.modelData.tipoDiscapacidadHijo1 = this.descendientes[0].tipoDiscapacidad;
                    this.modelData.movilidadReducidaHijo1 = this.descendientes[0].tipoDiscapacidad;
                    this.modelData.computoEnteroHijo1 = this.descendientes[0].tipoComputo;

                    this.modelData.anoNacimientoHijo2 = this.descendientes[1].anoNacimiento;
                    this.modelData.anoAdopcionHijo2 = this.descendientes[1].anoAdopcion;
                    this.modelData.tipoDiscapacidadHijo2 = this.descendientes[1].tipoDiscapacidad;
                    this.modelData.movilidadReducidaHijo2 = this.descendientes[1].tipoDiscapacidad;
                    this.modelData.computoEnteroHijo2 = this.descendientes[1].tipoComputo;

                    this.modelData.anoNacimientoHijo3 = this.descendientes[2].anoNacimiento;
                    this.modelData.anoAdopcionHijo3 = this.descendientes[2].anoAdopcion;
                    this.modelData.tipoDiscapacidadHijo3 = this.descendientes[2].tipoDiscapacidad;
                    this.modelData.movilidadReducidaHijo3 = this.descendientes[2].tipoDiscapacidad;
                    this.modelData.computoEnteroHijo3 = this.descendientes[2].tipoComputo;

                    this.modelData.anoNacimientoHijo4 = this.descendientes[3].anoNacimiento;
                    this.modelData.anoAdopcionHijo4 = this.descendientes[3].anoAdopcion;
                    this.modelData.tipoDiscapacidadHijo4 = this.descendientes[3].tipoDiscapacidad;
                    this.modelData.movilidadReducidaHijo4 = this.descendientes[3].tipoDiscapacidad;
                    this.modelData.computoEnteroHijo4 = this.descendientes[3].tipoComputo;

                    this.modelData.anoNacimientoHijo5 = this.descendientes[4].anoNacimiento;
                    this.modelData.anoAdopcionHijo5 = this.descendientes[4].anoAdopcion;
                    this.modelData.tipoDiscapacidadHijo5 = this.descendientes[4].tipoDiscapacidad;
                    this.modelData.movilidadReducidaHijo5 = this.descendientes[4].tipoDiscapacidad;
                    this.modelData.computoEnteroHijo5 = this.descendientes[4].tipoComputo;

                    this.modelData.anoNacimientoAsc1 = this.ascendientes[0].anoNacimiento;
                    this.modelData.tipoDiscapacidadAsc1 = this.ascendientes[0].tipoDiscapacidad;
                    this.modelData.movilidadReducidaAsc1 = this.ascendientes[0].conNecesidadAyuda;
                    this.modelData.numPersonasConvAsc1 = this.ascendientes[0].numPersonasConvivenc;

                    this.modelData.anoNacimientoAsc2 = this.ascendientes[1].anoNacimiento;
                    this.modelData.tipoDiscapacidadAsc2 = this.ascendientes[1].tipoDiscapacidad;
                    this.modelData.movilidadReducidaAsc2 = this.ascendientes[1].conNecesidadAyuda;
                    this.modelData.numPersonasConvAsc2 = this.ascendientes[1].numPersonasConvivenc;

                    
                        modelService.postModelData(this.modelData).then(response => {
                        
                        if (response.status == 200)
                            self.$router.push({name: 'model145'});                         
                    });                                
                }
            });
        },
        cancel() {
            this.$router.push({
                name: 'model145'
            });
        },
    }
}
</script>